import { path as ramdaPath } from 'ramda';
import { metrics } from 'system/libs/metrics';

import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

import s3 from '../../s3';

export const BUCKETS_REMOVE_START = 'BUCKETS_REMOVE_START';
export function actionRemoveStart({ Name }) {
    return {
        type: BUCKETS_REMOVE_START,
        data: { Name },
    };
}

export const BUCKETS_REMOVE_CANCEL = 'BUCKETS_REMOVE_CANCEL';
export function actionRemoveCancel() {
    return {
        type: BUCKETS_REMOVE_CANCEL,
    };
}

export const BUCKETS_REMOVE_REQUEST = 'BUCKETS_REMOVE_REQUEST';
function actionRemoveRequest() {
    return {
        type: BUCKETS_REMOVE_REQUEST,
    };
}

export const BUCKETS_REMOVE_SUCCESS = 'BUCKETS_REMOVE_SUCCESS';
function actionRemoveReceive({ Name }) {
    return {
        type: BUCKETS_REMOVE_SUCCESS,
        data: { Name },
    };
}

export const BUCKETS_REMOVE_FAILURE = 'BUCKETS_REMOVE_FAILURE';
function actionRemoveFailure() {
    return {
        type: BUCKETS_REMOVE_FAILURE,
    };
}

export function asyncActionRemove({ Name }) {
    return async function(dispatch) {
        dispatch(actionRemoveRequest());

        try {
            await s3('deleteBucket', { Bucket: Name });

            dispatch(actionRemoveReceive({ Name }));
            metrics.send({
                action: 'RemoveBucketSuccess',
            });
            ToastNotify.success('Bucket успешно удален');
        } catch (reason) {
            metrics.send({
                action: 'RemoveBucketError',
            });
            if (ramdaPath(['error', 'code'], reason) === 'BucketNotEmpty') {
                ToastNotify.error(
                    'Бакет, который вы пытались удалить, непустой',
                );
            } else {
                ToastNotify.error('Не удалось удалить бакет');
            }

            dispatch(actionRemoveFailure());
        }
    };
}
